/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Watch for variant option changes and handle quotify visibility
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for changes on variant option inputs
    var variantInputs = document.querySelectorAll('input[name^="options"]');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Get product data
        var productFormScript = document.querySelector('[data-product-json]');
        if (productFormScript) {
          var product = JSON.parse(productFormScript.textContent);

          // Get currently selected options
          var selectedOptions = [];
          document.querySelectorAll('input[name^="options"]:checked').forEach(function(opt) {
            selectedOptions.push(opt.value);
          });

          // Find matching variant
          var currentVariant = product.variants.find(function(v) {
            return v.options.every(function(option, index) {
              return option === selectedOptions[index];
            });
          });

          // Hide/show quotify button based on availability
          if (currentVariant) {
            var quotifyBlocks = document.querySelectorAll('[class*="quotify"]');
            quotifyBlocks.forEach(function(block) {
              if (currentVariant.available) {
                block.style.display = '';
              } else {
                block.style.display = 'none';
              }
            });
          }
        }
      });
    });
  });

 document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('[Custom] Variant changed:', variant.title);

      // Update variant option displays
      updateVariantOptionDisplays(variant, container);

      // Update product image to variant featured image
      updateProductImage(variant, container);

      // Hide/show Quotify button based on availability
      var quotifyBlocks = document.querySelectorAll('[class*="quotify"]');
      quotifyBlocks.forEach(function(block) {
        if (variant.available) {
          block.style.display = '';
        } else {
          block.style.display = 'none';
        }
      });
    }
  });

  // Function to update variant option displays
  function updateVariantOptionDisplays(variant, container) {
    // Update all data-option-value elements (these show the selected option value)
    var optionValueElements = container.querySelectorAll('[data-option-value]');

    if (variant.options && optionValueElements.length > 0) {
      // Update each option value display
      variant.options.forEach(function(optionValue, index) {
        if (optionValueElements[index]) {
          optionValueElements[index].textContent = optionValue;
        }
      });
    }

    // Also update data-swapper-target elements (alternative display method)
    var swapperTargets = container.querySelectorAll('[data-swapper-target]');
    swapperTargets.forEach(function(element) {
      // Find the closest parent that has data-option-position to know which option this is for
      var wrapper = element.closest('[data-option-position]');
      if (wrapper) {
        var optionPosition = parseInt(wrapper.getAttribute('data-option-position')) - 1;
        if (variant.options && variant.options[optionPosition] !== undefined) {
          element.textContent = variant.options[optionPosition];
        }
      }
    });
  }

  // Function to update product image
  function updateProductImage(variant, container) {
    // Only update if variant has a featured image
    if (!variant.featured_media || !variant.featured_media.preview_image) {
      return;
    }

    var variantImageSrc = variant.featured_media.preview_image.src;
    var variantImageId = variant.featured_media.id;

    console.log('[Custom] Updating to variant image:', variantImageSrc);

    // Find the product slideshow/grid container
    var productSlideshow = container.querySelector('[data-product-slideshow]');
    if (!productSlideshow) {
      return;
    }

    // Check if we're in slideshow mode or grid mode
    var isSlideshow = productSlideshow.classList.contains('flickity-enabled');

    if (isSlideshow) {
      // Handle slideshow mode - find the slide with matching media ID
      var targetSlide = productSlideshow.querySelector('[data-media-id="' + variantImageId + '"]');
      if (targetSlide) {
        var slideIndex = Array.from(targetSlide.parentElement.children).indexOf(targetSlide);

        // Use Flickity API to select the slide
        if (window.Flickity) {
          var flkty = Flickity.data(productSlideshow);
          if (flkty) {
            flkty.select(slideIndex);
          }
        }
      }
    } else {
      // Handle grid/stacked mode - scroll to the image
      var targetMedia = productSlideshow.querySelector('[data-media-id="' + variantImageId + '"]');
      if (targetMedia) {
        // Smooth scroll to the image
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // Also update thumbnails if present
        updateThumbnailSelection(variantImageId, container);
      }
    }
  }

  // Function to update thumbnail selection
  function updateThumbnailSelection(mediaId, container) {
    // Remove active class from all thumbnails
    var thumbnails = container.querySelectorAll('[data-slideshow-thumbnail]');
    thumbnails.forEach(function(thumb) {
      thumb.classList.remove('is-activated');
    });

    // Add active class to matching thumbnail
    var activeThumbnail = container.querySelector('[data-media-select="' + mediaId + '"]');
    if (activeThumbnail) {
      activeThumbnail.classList.add('is-activated');
    }
  }


  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // Check and apply gift card bonuses
      try { setTimeout(checkAndApplyBonuses, 100); } catch(e) {}
      // Check buy-product-get-gift promo
      setTimeout(function() { checkProductGwp(cart); }, 200);
      // Check tiered GWP thresholds
      setTimeout(function() { checkTieredGwp(cart); }, 300);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
    // Check and apply gift card bonuses on init
    try { checkAndApplyBonuses(); } catch(e) {}
    // Check buy-product-get-gift promo on init
    if (e.detail && e.detail.cart) checkProductGwp(e.detail.cart);
    // Check tiered GWP on init
    if (e.detail && e.detail.cart) checkTieredGwp(e.detail.cart);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // =====================================================
  // TIERED GWP — Anniversary Sale
  // $349+: Hydrinity Restorative HA 15ml
  // $499+: Hydrinity Vivid Brightening 15ml (additive, both stay)
  // =====================================================
  var tieredGwpRunning = false;
  var TIERED_GWP = [
    { threshold: 34900, variantId: 45055580962839 },  // Restorative HA 15ml
    { threshold: 49900, variantId: 45012672249879 }   // Vivid Brightening 15ml
  ];
  var TIERED_GWP_IDS = TIERED_GWP.map(function(t) { return t.variantId; });
  var QTY_LIMITED_TIERED_GWP_IDS = [45012672249879];

  function checkTieredGwp(cart) {
    if (tieredGwpRunning || !cart) return;

    // Cart total in cents, excluding GWP items
    var cartTotal = 0;
    cart.items.forEach(function(item) {
      var isGwp = item.properties && item.properties._gwp_tier;
      if (!isGwp) {
        cartTotal += item.final_line_price;
      }
    });

    // Determine which gifts should be in the cart
    var giftsEarned = [];
    TIERED_GWP.forEach(function(tier) {
      if (cartTotal >= tier.threshold) {
        giftsEarned.push(tier.variantId);
      }
    });

    // Find which GWP items are currently in cart
    var giftsInCart = [];
    var giftsToLimit = [];
    cart.items.forEach(function(item) {
      if (item.properties && item.properties._gwp_tier && TIERED_GWP_IDS.indexOf(item.variant_id) !== -1) {
        if (giftsInCart.indexOf(item.variant_id) === -1) {
          giftsInCart.push(item.variant_id);
        }
        if (
          giftsEarned.indexOf(item.variant_id) !== -1 &&
          QTY_LIMITED_TIERED_GWP_IDS.indexOf(item.variant_id) !== -1 &&
          item.quantity !== 1 &&
          giftsToLimit.indexOf(item.variant_id) === -1
        ) {
          giftsToLimit.push(item.variant_id);
        }
      }
    });

    // Gifts to add (earned but not in cart)
    var toAdd = giftsEarned.filter(function(id) { return giftsInCart.indexOf(id) === -1; });
    // Gifts to remove (in cart but no longer earned)
    var toRemove = giftsInCart.filter(function(id) { return giftsEarned.indexOf(id) === -1; });

    if (toAdd.length === 0 && toRemove.length === 0 && giftsToLimit.length === 0) return;

    tieredGwpRunning = true;

    // Build a single updates request for removals
    var removePromises = toRemove.map(function(id) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: 0 })
      });
    });

    var limitPromises = giftsToLimit.map(function(id) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: 1 })
      });
    });

    // Build add requests
    var addPromises = toAdd.map(function(id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, properties: { '_gwp_tier': 'anniversary_sale' } })
      });
    });

    // Run removals first, then additions, then reload cart
    Promise.all(removePromises)
      .then(function() { return Promise.all(limitPromises); })
      .then(function() { return Promise.all(addPromises); })
      .then(function() {
        tieredGwpRunning = false;
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function() { tieredGwpRunning = false; });
  }

  // =====================================================
  // BUY PRODUCT, GET GIFT — configurable via theme settings
  // =====================================================
  var productGwpRunning = false;

  function checkProductGwp(cart) {
    if (productGwpRunning) return;
    var body = document.body;
    var triggerProductId = body.dataset.productGwpTriggerProductId;
    var triggerVariantId = body.dataset.productGwpTriggerVariantId;
    var giftVariantId = body.dataset.productGwpGiftVariantId;

    if (!triggerProductId || !giftVariantId) return;

    triggerProductId = parseInt(triggerProductId, 10);
    giftVariantId = parseInt(giftVariantId, 10);
    if (triggerVariantId) triggerVariantId = parseInt(triggerVariantId, 10);

    var hasTrigger = false;
    var hasGift = false;

    cart.items.forEach(function(item) {
      if (triggerVariantId) {
        if (item.variant_id === triggerVariantId) hasTrigger = true;
      } else {
        if (item.product_id === triggerProductId) hasTrigger = true;
      }
      if (item.variant_id === giftVariantId) hasGift = true;
    });

    if (hasTrigger && !hasGift) {
      productGwpRunning = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftVariantId, quantity: 1, properties: { '_gift_with_purchase': 'Free gift!' } })
      }).then(function() {
        productGwpRunning = false;
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }).catch(function() { productGwpRunning = false; });
    } else if (!hasTrigger && hasGift) {
      productGwpRunning = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(giftVariantId), quantity: 0 })
      }).then(function() {
        productGwpRunning = false;
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      }).catch(function() { productGwpRunning = false; });
    }
  }

  // Run initial gift card bonus check + product GWP check + tiered GWP on page load
  document.addEventListener("DOMContentLoaded", function() {
    checkAndApplyBonuses();
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      if (document.body.dataset.productGwpTriggerProductId) checkProductGwp(cart);
      checkTieredGwp(cart);
    }).catch(function() {});
  });

  // Add ?tab= param to FAQ links based on current page context
  document.addEventListener('DOMContentLoaded', function() {
    if (!window.location.pathname.match(/\/pages\/(faq|frequently-asked-questions)/)) {
      var faqTab = document.body.classList.contains('is-service-page') ? 'clinic' : 'shop';
      document.querySelectorAll('a[href*="/pages/faq"], a[href*="/pages/frequently-asked-questions"]').forEach(function(link) {
        if (link.href.indexOf('tab=') === -1) {
          link.href = link.href.split('?')[0] + '?tab=' + faqTab;
        }
      });
    }
  });

  // Hide Klaviyo widgets on service pages
  if (document.body.classList.contains('is-service-page')) {
    var removeKlaviyo = function() {
      document.querySelectorAll('[class*="klaviyo"], iframe[src*="klaviyo"], [id*="klaviyo"]').forEach(function(el) {
        el.remove();
      });
    };
    removeKlaviyo();
    var klaviyoObserver = new MutationObserver(function() {
      removeKlaviyo();
    });
    klaviyoObserver.observe(document.body, { childList: true, subtree: true });
    // Stop observing after 10 seconds to avoid performance impact
    setTimeout(function() { klaviyoObserver.disconnect(); }, 10000);
  }

  // FAQ Tab Switcher + Search
  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.querySelector('[data-faq-search-input]');
    var searchClear = document.querySelector('[data-faq-search-clear]');
    var tabButtons = document.querySelectorAll('[data-faq-tab]');
    var tabsContainer = document.querySelector('.faq-tabs');

    if (!tabButtons.length) return;

    var faqSections = document.querySelectorAll('[data-faq-group]');
    var searchDebounceTimer = null;
    var noResultsEl = null;

    // Read ?tab= param to determine initial tab and order
    var urlParams = new URLSearchParams(window.location.search);
    var initialTab = urlParams.get('tab') === 'shop' ? 'shop' : 'clinic';
    var lastActiveTab = initialTab;

    // Reorder tab buttons so the active tab is on the left
    if (initialTab === 'shop' && tabsContainer) {
      var shopBtn = tabsContainer.querySelector('[data-faq-tab="shop"]');
      if (shopBtn) {
        tabsContainer.insertBefore(shopBtn, tabsContainer.firstChild);
      }
    }

    function setActiveTab(activeTab) {
      lastActiveTab = activeTab;

      tabButtons.forEach(function(btn) {
        var isActive = btn.getAttribute('data-faq-tab') === activeTab;
        btn.classList.toggle('faq-tabs__btn--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      faqSections.forEach(function(section) {
        var group = section.getAttribute('data-faq-group');
        var wrapper = section.closest('.shopify-section');
        var target = wrapper || section;
        target.style.display = (group === activeTab) ? 'block' : 'none';
        section.style.display = (group === activeTab) ? 'block' : 'none';

        section.classList.remove('faq-section-hidden');
        var items = section.querySelectorAll('.accordion__wrapper');
        items.forEach(function(item) {
          item.classList.remove('faq-hidden');
        });
      });

      removeNoResults();
    }

    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (searchInput && searchInput.value.trim() !== '') {
          searchInput.value = '';
          searchClear.style.display = 'none';
          exitSearchMode();
        }
        var tab = btn.getAttribute('data-faq-tab');
        setActiveTab(tab);
        var newUrl = window.location.pathname + '?tab=' + tab;
        history.replaceState(null, '', newUrl);
      });
    });

    setActiveTab(initialTab);

    if (!searchInput) return;

    function enterSearchMode() {
      if (tabsContainer) {
        tabsContainer.classList.add('faq-tabs--search-active');
      }
      faqSections.forEach(function(section) {
        var wrapper = section.closest('.shopify-section');
        var target = wrapper || section;
        target.style.display = 'block';
        section.style.display = 'block';
      });
    }

    function exitSearchMode() {
      if (tabsContainer) {
        tabsContainer.classList.remove('faq-tabs--search-active');
      }
      removeNoResults();

      faqSections.forEach(function(section) {
        section.classList.remove('faq-section-hidden');
        var items = section.querySelectorAll('.accordion__wrapper');
        items.forEach(function(item) {
          item.classList.remove('faq-hidden');
        });
      });

      setActiveTab(lastActiveTab);
    }

    function removeNoResults() {
      if (noResultsEl && noResultsEl.parentNode) {
        noResultsEl.parentNode.removeChild(noResultsEl);
        noResultsEl = null;
      }
    }

    function showNoResults() {
      removeNoResults();
      noResultsEl = document.createElement('div');
      noResultsEl.className = 'faq-search-no-results wrapper--narrow';
      noResultsEl.textContent = 'We couldn\u2019t find an exact match, but here are a few related questions:';

      var tabsSection = document.querySelector('[data-section-type="faq-tabs"]');
      if (tabsSection) {
        var tabsWrapper = tabsSection.closest('.shopify-section');
        var insertAfter = tabsWrapper || tabsSection;
        insertAfter.parentNode.insertBefore(noResultsEl, insertAfter.nextSibling);
      }
    }

    function performSearch(query) {
      query = query.toLowerCase().trim();

      if (query === '') {
        exitSearchMode();
        return;
      }

      enterSearchMode();

      var totalMatches = 0;

      faqSections.forEach(function(section) {
        var items = section.querySelectorAll('.accordion__wrapper');
        var sectionMatches = 0;

        items.forEach(function(item) {
          var title = item.querySelector('.accordion__title');
          var body = item.querySelector('.accordion__body');

          var titleText = title ? title.textContent.toLowerCase() : '';
          var bodyText = body ? body.textContent.toLowerCase() : '';

          if (titleText.indexOf(query) !== -1 || bodyText.indexOf(query) !== -1) {
            item.classList.remove('faq-hidden');
            sectionMatches++;
            totalMatches++;
          } else {
            item.classList.add('faq-hidden');
          }
        });

        if (sectionMatches === 0) {
          section.classList.add('faq-section-hidden');
        } else {
          section.classList.remove('faq-section-hidden');
        }
      });

      if (totalMatches === 0) {
        showNoResults();
        faqSections.forEach(function(section) {
          section.classList.remove('faq-section-hidden');
          var items = section.querySelectorAll('.accordion__wrapper');
          items.forEach(function(item) {
            item.classList.remove('faq-hidden');
          });
        });
      } else {
        removeNoResults();
      }
    }

    searchInput.addEventListener('input', function() {
      var value = searchInput.value;
      searchClear.style.display = value.length > 0 ? 'block' : 'none';

      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function() {
        performSearch(value);
      }, 250);
    });

    searchClear.addEventListener('click', function() {
      searchInput.value = '';
      searchClear.style.display = 'none';
      exitSearchMode();
      searchInput.focus();
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        searchClear.style.display = 'none';
        exitSearchMode();
        searchInput.blur();
      }
    });
  });

  // FAQ Search Integration — inject FAQ results into predictive search + search page
  (function() {
    var faqData = null;
    var faqFetchPromise = null;
    var FAQ_PAGE_URL = '/pages/frequently-asked-questions';
    var MAX_FAQ_RESULTS = 5;

    function fetchFaqData() {
      if (faqData) return Promise.resolve(faqData);
      if (faqFetchPromise) return faqFetchPromise;

      faqFetchPromise = fetch(FAQ_PAGE_URL)
        .then(function(res) {
          if (!res.ok) throw new Error('FAQ page returned ' + res.status);
          return res.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sections = doc.querySelectorAll('[data-faq-group]');
          var items = [];

          sections.forEach(function(section) {
            var group = section.getAttribute('data-faq-group');
            section.querySelectorAll('.accordion__wrapper').forEach(function(wrapper) {
              var titleEl = wrapper.querySelector('button.accordion__title');
              var bodyEl = wrapper.querySelector('.accordion__body');
              if (!titleEl || !bodyEl) return;
              items.push({
                question: titleEl.textContent.trim(),
                answer: bodyEl.textContent.replace(/\s+/g, ' ').trim(),
                group: group || ''
              });
            });
          });

          faqData = items;
          return faqData;
        })
        .catch(function(err) {
          console.warn('FAQ search: could not load FAQ data', err);
          faqFetchPromise = null;
          return [];
        });

      return faqFetchPromise;
    }

    function searchFaqs(query) {
      if (!faqData || !query) return [];
      var terms = query.toLowerCase().split(/\s+/).filter(Boolean);
      return faqData.filter(function(item) {
        var searchable = (item.question + ' ' + item.answer).toLowerCase();
        return terms.every(function(t) { return searchable.indexOf(t) !== -1; });
      }).slice(0, MAX_FAQ_RESULTS);
    }

    function truncate(str, len) {
      if (str.length <= len) return str;
      return str.substring(0, len).replace(/\s+\S*$/, '') + '…';
    }

    // ── Predictive search dropdown ──────────────────────────────────

    function buildDropdownMarkup(matches) {
      var html = '<div class="search__results__other__list faq-search-results">';
      html += '<div class="search__results__heading">';
      html += '<p class="search__results__title">FAQ</p>';
      html += '<span class="badge">' + matches.length + '</span>';
      html += '</div>';
      html += '<ul aria-label="Frequently Asked Questions" role="group">';
      matches.forEach(function(item, i) {
        var tabParam = item.group ? '?tab=' + item.group : '';
        html += '<li class="other__inline faq-search-result animates" style="animation-delay: ' + ((i + 1) * 90 + 10) + 'ms;" role="option" aria-selected="false">';
        html += '<p class="other__inline__title"><a href="' + FAQ_PAGE_URL + tabParam + '">' + item.question + '</a></p>';
        html += '<p class="faq-search-result__snippet">' + truncate(item.answer, 120) + '</p>';
        html += '</li>';
      });
      html += '</ul></div>';
      return html;
    }

    function injectIntoDropdown(container) {
      // Clean up previous injection
      container.querySelectorAll('.faq-search-results, .faq-search-loader').forEach(function(el) { el.remove(); });

      var psElement = container.closest('predictive-search');
      if (!psElement) return;
      var input = psElement.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;
      var query = input.value.trim();
      if (query.length < 2) return;

      if (!faqData) {
        // Show loader, wait for data, then inject
        var otherEl = container.querySelector('.search__results__other');
        if (otherEl) {
          var loader = document.createElement('div');
          loader.className = 'search__results__other__list faq-search-loader';
          loader.innerHTML = '<div class="search__results__heading"><p class="search__results__title">FAQ</p></div><div class="faq-loader-dots"><span></span><span></span><span></span></div>';
          otherEl.appendChild(loader);
        }
        fetchFaqData().then(function() { injectIntoDropdown(container); });
        return;
      }

      var matches = searchFaqs(query);
      if (!matches.length) return;

      var markup = buildDropdownMarkup(matches);
      var other = container.querySelector('.search__results__other');
      var empty = container.querySelector('.search__results__empty');

      if (empty && !other) {
        var wrap = document.createElement('div');
        wrap.className = 'search__results__outer';
        wrap.innerHTML = '<div class="search__results__other">' + markup + '</div>';
        empty.parentNode.insertBefore(wrap, empty);
        empty.style.display = 'none';
      } else if (other) {
        other.insertAdjacentHTML('beforeend', markup);
      }
    }

    function setupObservers() {
      document.querySelectorAll('[data-predictive-search-results]').forEach(function(container) {
        new MutationObserver(function() {
          injectIntoDropdown(container);
        }).observe(container, { childList: true });
        // childList only (no subtree) — PredictiveSearch replaces direct
        // children via innerHTML; our injection targets descendants, so it
        // will NOT re-trigger this observer.
      });
    }

    // ── Full search results page ────────────────────────────────────

    function initSearchPageFaq() {
      var section = document.querySelector('[data-section-type="search-page"]');
      if (!section) return;

      var query = (new URLSearchParams(window.location.search).get('q') || '').trim();
      if (query.length < 2) return;

      var heading = section.querySelector('.search__page__heading');
      if (!heading) return;

      var el = document.createElement('div');
      el.className = 'faq-search-page-results';
      el.innerHTML = '<div class="faq-search-page-header"><h3 class="faq-search-page-title">Frequently Asked Questions</h3></div><div class="faq-loader-dots"><span></span><span></span><span></span></div>';
      heading.parentNode.insertBefore(el, heading.nextSibling);

      fetchFaqData().then(function(data) {
        if (!data || !data.length) { el.remove(); return; }

        var matches = searchFaqs(query);
        if (!matches.length) { el.remove(); return; }

        var html = '<div class="faq-search-page-header">';
        html += '<h3 class="faq-search-page-title">Frequently Asked Questions</h3>';
        html += '<a href="' + FAQ_PAGE_URL + '" class="faq-search-page-view-all">View all FAQ &rarr;</a>';
        html += '</div><div class="faq-search-page-list">';
        matches.forEach(function(item) {
          var tabParam = item.group ? '?tab=' + item.group : '';
          html += '<div class="faq-search-page-item">';
          html += '<a href="' + FAQ_PAGE_URL + tabParam + '" class="faq-search-page-question">' + item.question + '</a>';
          html += '<p class="faq-search-page-answer">' + truncate(item.answer, 200) + '</p>';
          html += '</div>';
        });
        html += '</div>';
        el.innerHTML = html;

        // Hide "No results for" message when FAQ matches exist
        var noResultsMsg = section.querySelector('.search__page__query');
        if (noResultsMsg && noResultsMsg.textContent.indexOf('No results') !== -1) {
          noResultsMsg.style.display = 'none';
        }
      });
    }

    // ── Bootstrap ───────────────────────────────────────────────────

    // Pre-fetch on first search focus so data is ready when needed
    document.addEventListener('focusin', function(e) {
      if (e.target.matches && e.target.matches('input[name="q"], [data-predictive-search-input]')) {
        fetchFaqData();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setupObservers();
        initSearchPageFaq();
      });
    } else {
      setupObservers();
      initSearchPageFaq();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
